<template>
  <component
    :is="tag"
    v-if="inAppCheck && componentIsActive && (showBanner && !disableBannerViaExternalAuthCode) && showComponentInVMXOnly"
    :class="[boxClasses, isApp && inAppAppearanceActive ? 'in-app-linkbox-style' : '', variant, positionIconAbsolute ? 'icon-position-absolute' : '']"
    :style="[boxStyles, heroStyles, useHoverStyles && hoverStyles]"
    v-bind="tagProps"
    @mouseover="useHoverStyles && (hover = true)"
    @mouseleave="useHoverStyles && (hover = false)"
    @click="action(tagProps)"
  >
    <div
      class="link-box-content"
      @click="tracking"
    >
      <slot>
        <template v-if="isApp && inAppAppearanceActive">
          <div
            v-if="iconImagePath"
          >
            <img
              class="link-box__icon-image-path"
              :src="iconImagePath"
            />
          </div>
          <div
            v-else-if="icon"
            class="link-box__icon"
          >
            <font-awesome-icon :icon="[fas, icon]" />
          </div>
          <div
            v-if="!image"
            :class="['link-box__text', isTable && 'table-style' ]"
          >
            <div
              v-if="showTitle"
              :class="[sectionTitle ? `link-box__sectionTitle` :`link-box__title`]"
            >
              <slot name="title">
                <div v-html="title" :style="`font-size:${cssProps.titleSize};`" />
              </slot>
            </div>
            <div
              v-if="showDescription"
              :class="[sectionDescription ? `link-box__sectionDescription` :`link-box__description`]"
            >
              <slot name="description">
                <div v-html="formatedDescription" :style="`font-size:${cssProps.descSize};`" />
              </slot>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-if="!image"
            :class="['link-box__text', isTable && 'table-style' ]"
          >
            <div
              v-if="showTitle"
              :class="[sectionTitle ? `link-box__sectionTitle` :`link-box__title`]"
            >
              <slot name="title">
                <div v-html="title" :style="`font-size:${cssProps.titleSize};`" />
              </slot>
            </div>
            <div
              v-if="showDescription"
              :class="[sectionDescription ? `link-box__sectionDescription` :`link-box__description`]"
            >
              <slot name="description">
                <div v-html="formatedDescription" :style="`font-size:${cssProps.descSize};`" />
              </slot>
            </div>
            <template v-if="Object.keys(cta).length">
              <div class="link-box__cta">
                <template v-if="cta.link">
                  <a class="btn btn-primary" :href="cta.link" :target="cta.target">
                    {{ cta.description }}
                    <template v-if="cta.icon">
                      <font-awesome-icon :icon="[fas, cta.icon]" />
                    </template>
                  </a>
                </template>
              </div>
            </template>
            <template v-else-if="ctaLink">
              <div class="link-box__cta">
                <a class="btn btn-primary" :href="ctaLink" :target="ctaTarget ">
                  {{ ctaDescription }}
                  <template v-if="ctaIcon">
                    <font-awesome-icon :icon="[fas, ctaIcon]" />
                  </template>
                </a>
              </div>
            </template>
          </div>
          <div
            v-if="iconImagePath"
            class="link-box__icon"
          >
            <img
              class="link-box__icon-image-path"
              :src="iconImagePath"
            />
          </div>
          <div
            v-else-if="icon"
            class="link-box__icon"
          >
            <font-awesome-icon :icon="[fas, icon]" />
          </div>
        </template>

        <template v-if="image && imageMap">
          <img
            :src="image"
            class="link-box__image"
            usemap="#image-map"
          />
        </template>

        <template v-else-if="image">
          <img
            :src="image"
            class="link-box__image"
          />
        </template>

        <template v-if="imageMap">
          <map
            id="imagemapHeader"
            name="image-map"
          >
            <area
              alt="Membership"
              coords="451, 1348, 1462, 1698"
              shape="rect"
              target="_blank"
              title="Membership"
              @click="
                goToArea(
                  'Tawk-to-chat',
                  'Membership',
                  'https://tawk.to/chat/5f2122255e51983a11f5fc96/default',
                  '_blank'
                )
              "
            />
          </map>
        </template>
        <modal
          :show="videoModal.show"
          @close="videoModal.show = false"
        >
          <video-player
            :options="videoOptions"
            class="embed-responsive"
          />
        </modal>
      </slot>
    </div>
    <modal
      :show="iframeModal"
      :show-iframe-modal-content="true"
      @close="iframeModal = false"
    >
      <iframe
        :id="wallsIo.id"
        :loading="wallsIo.loading"
        :src="wallsIo.src"
        :style="wallsIo.style"
        :title="wallsIo.title"
        allowfullscreen
      />
    </modal>
    <modal
      :show="videoPropModal.show"
      @close="videoPropModal.show = false"
    >
      <div class="linkbox-modal-container">
        <span>{{ videoTitle }}</span>
        <video-player
          :options="videoPropOptions"
          class="embed-responsive"
        />
      </div>
    </modal>
    <modal
      :show="liveDabModal"
      @close="liveDabModal = false"
    >
      <liveDabComponent
        :stream-overlay="liveDabSetup.streamOverlay"
        :stream-widget="liveDabSetup.streamWidget"
        :qr-code-text="liveDabSetup.qrCodeText || ''"
        :qr-code="liveDabSetup.qrCode || ''"
      />
    </modal>
  </component>

</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'

import { mapGetters } from 'vuex'
import tracking from '~/utilities/tracking'
import { replaceCssVar } from '../utilities/theme'
import config from '../config'
import trackingApi from '~/api/tracking'

import utils from '../utilities'
import modal from '../Modal/index.vue'
import videoPlayer from '../VideoPlayer/index.vue'
import componentIsActiveMixins from '../mixins/componentIsActiveMixins'
import externalTrackingMixin from '../mixins/externalTrackingMixins'
import liveDabComponent from '../CustomComponents/LiveDabComponent'
import appContainerMixins from "../mixins/appContainerMixins"
import userState from '~/states/user'

Vue.use(VueCookies)

export default {
  name: 'LinkBox',
  data() {
    return {
      iframeClass: '',
      liveDabClass: '',
      hover: false,
      showBanner: false,
      videoModal: {
        show: false,
      },
      videoPropModal: {
        show: false,
      },
      iframeModal: false,
      liveDabModal: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  mixins: [
    componentIsActiveMixins.componentProps,
    componentIsActiveMixins.method,
    externalTrackingMixin,
    appContainerMixins,
  ],
  components: {
    videoPlayer,
    modal,
    liveDabComponent,
  },
  props: {
    componentName: {
      type: String,
      default: 'LinkBox',
    },
    inAppAppearanceActive: {
      type: Boolean,
      default: false,
    },
    isTable: {
      type: Boolean,
      default: false,
    },
    link: {
      type: [String, Object],
      default: null,
    },
    trackingContent: {
      type: Object,
      default: null,
    },
    navigationHelper: {
      type: String,
      default: null,
    },
    trackingId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    titleSize: {
      type: String,
      default: null,
    },
    titleSizeApp: {
      type: String,
      default: null,
    },
    descSize: {
      type: String,
      default: null,
    },
    descSizeApp: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    imageMap: {
      type: Boolean,
      default: false,
    },
    useHoverStyles: {
      type: Boolean,
      default: false,
    },
    iframe: {
      type: Boolean,
      default: false,
    },
    video: {
      type: Boolean,
      default: false,
    },
    searchFilter: {
      type: Object,
      default: null,
    },
    videoTitle: {
      type: String,
      default: 'The title of your video',
    },
    videoPropOptions: {
      type: Object,
      default() {
        return {
          autoplay: true,
          controls: true,
          fluid: true,
          sources: [
            {
              src: '',
              type: 'video/mp4',
            },
          ],
        }
      },
    },
    wallsIo: {
      type: Object,
      default() {
        return {
          id: 'wallsio-iframe',
          src: 'https://my.walls.io/d4ipm?nobackground=1&amp;show_header=0',
          style: 'border:0;height:800px;width:100%',
          loading: 'lazy',
          title: 'ERA-EDTA Social Media Wall',
        }
      },
    },
    customModal: {
      type: Boolean,
      default: false,
    },
    liveDabSetup: {
      type: Object,
      default() {
        return {}
      },
    },
    aspect: {
      type: String,
      default: null,
    },
    iconImagePath: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    fas: {
      type: String,
      default: 'fas',
    },
    backgroundImage: {
      type: String,
      default: null,
    },
    backgroundImageRepeat: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: 'var(--primary)',
    },
    backgroundColorGradient: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: 'var(--primary-contrast)',
    },
    disableBannerViaAuthCode: {
      type: Boolean,
      default: false,
    },
    displayOnPage: {
      type: Array,
      default() {
        return []
      },
    },
    bannerTimeout: {
      type: Number,
      default: 0,
    },
    sectionTitle: {
      type: Boolean,
      default: false,
    },
    sectionDescription: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "",
    },
    heroHeight: {
      type: String,
      default: "50vh",
    },
    positionIconAbsolute: {
      type: Boolean,
      default: false,
    },
    onlyInVMX: {
      type: Boolean,
      default: false,
    },
    inApp: {
      type: Boolean,
      default: true,
    },
    onlyInApp: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: String,
      default: '',
    },
    qnaInstance: {
      type: String,
      default: '',
    },
    cta: {
      type: Object,
      default() {
        return {}
      }
    },
    hoverStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    ctaLink: {
      type: String,
      default: '',
    },
    ctaDescription: {
      type: String,
      default: '',
    },
    ctaTarget: {
      type: String,
      default: '_blank',
    },
    ctaIcon: {
      type: String,
      default: '',
    }
  },
  mounted() {
    window.addEventListener('disableBanner', this.receiveMessage)
    window.addEventListener('activateBanner', this.receiveMessage)
    window.addEventListener('bannerControl', this.receiveMessage)
    window.addEventListener('interceptUrl', this.receiveMessage)
    if (this.displayOnPage.length === 0) {
      setTimeout(() => {
        this.showBanner = true
      }, this.bannerTimeout)
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      configForKey: 'config/configForKey',
      instance: 'instancesState/getInstance',
      token: 'instancesState/getToken',
      inVMX: 'instancesState/getInVMX',
      isAppContainer: 'instancesState/getIsAppContainer'
    }),
    appConfigV2() {
      const appConfigV2 = this.configForKey('app_config')
      if (appConfigV2.configV2) {
        return appConfigV2.configV2
      }
      return null
    },
    userState() {
      return userState.getUser(this.instance)
    },
    isApp() {
      return localStorage.getItem('isApp') === 'true'
    },
    newExternalAuthRedirect() {
      return 'newExternalAuthRedirect' in this.appConfigV2.defaultV2 ? this.appConfigV2.defaultV2.newExternalAuthRedirect : false
    },
    defaultsConfig() {
      const config = this.configForKey('app_config').config[0]
      return config.defaults
    },
    showComponentInVMXOnly() {
      if (this.onlyInVMX && this.inVMX) return true
      if (this.onlyInVMX && !this.inVMX) return false
      return true
    },
    disableBannerViaExternalAuthCode() {
      if (this.disableBannerViaAuthCode) {
        if (this.$cookies.get('externalAuthorizationCode')) {
          return false
        }
        return true
      }
      return false
    },
    tag() {
      if (this.iframe || this.video) {
        return 'a'
      }
      if (!this.link || this.checkHref(this.link) === null || ((this.dataType === 'pdf' || this.dataType === 'link' || this.dataType === 'qnalink'))) {
        return 'div'
      }
      if (!utils.isObject(this.link) && utils.isUrl(this.link)) {
        return 'a'
      }
      if (!this.newExternalAuthRedirect && utils.isObject(this.link) && this.defaultsConfig?.ticketSync && (this.link.name === 'CreateAccountPage' || this.link.name === 'LoginPage')) {
        return 'a'
      }
      if (this.newExternalAuthRedirect && utils.isObject(this.link) && this.defaultsConfig?.ticketSync && (this.link.name === 'CreateAccountPage' || this.link.name === 'LoginPage')) {
        return 'a'
      }
      return 'router-link'
    },
    tagProps() {
      if (!this.link) {
        return {}
      }
      const props = {}
      if (!this.newExternalAuthRedirect && utils.isObject(this.link) && this.defaultsConfig?.ticketSync && (this.link.name === 'CreateAccountPage' || this.link.name === 'LoginPage')) {
        const params = {
          context: 'Event',
          shortname: this.$route.params.event,
          language: this.$route.params.language,
        }
        const { identityUrl } = config.getInstanceConfig(this.$route.params.instance)
        if (this.link.name === 'CreateAccountPage') {
          const query = `externalAuthorizationCode=${this.$cookies.get('externalAuthorizationCode')}`
          params.returnUrl = `${window.location.origin}/home/${this.$route.params.instance}/${this.$route.params.event}/${this.$route.params.language}?${query}`
          params.externalAuthorizationCode = `${this.$cookies.get('externalAuthorizationCode')}`
          const identityParams = utils.queryString(params)
          props.href = `${identityUrl}/Account/RegisterWithCode?${identityParams}`
        } else if (this.link.name === 'LoginPage') {
          const query = `externalAuthorizationCode=${this.$cookies.get('externalAuthorizationCode')}`
          params.returnUrl = `${window.location.origin}/home/${this.$route.params.instance}/${this.$route.params.event}/${this.$route.params.language}?${query}`
          params.externalAuthorizationCode = `${this.$cookies.get('externalAuthorizationCode')}`
          const identityParams = utils.queryString(params)
          props.href = `${identityUrl}/Account/Login?${identityParams}`
        }
      } else if (this.newExternalAuthRedirect && utils.isObject(this.link) && this.defaultsConfig?.ticketSync && (this.link.name === 'CreateAccountPage' || this.link.name === 'LoginPage')) {
        const params = {}

        const { identityUrl } = config.getInstanceConfig(this.$route.params.instance)
        const prevQuery = JSON.parse(localStorage.getItem('externalAuthReturnUrl'))
        if (this.link.name === 'CreateAccountPage') {
          if(prevQuery) params.returnUrl = `${window.location.origin}${prevQuery.path}`
          const identityParams = utils.queryString(params)
          props.href = `${window.location.origin}/createaccount/${this.$route.params.instance}/${this.$route.params.event}/${this.$route.params.language}?${identityParams}`
        } else if (this.link.name === 'LoginPage') {
          if(prevQuery)params.returnUrl = `${window.location.origin}${prevQuery.path}`
          const identityParams = utils.queryString(params)
          props.href = `${window.location.origin}/login/${this.$route.params.instance}/${this.$route.params.event}/${this.$route.params.language}?${identityParams}`
        }
      } else if (this.dataType === 'tokenlink' && this.userState) {
         const token = this.userState ? this.userState.accessToken : null
         if (this.$store.getters['config/configForKey']('app_config').config[0].addTokenToEvaluationLink) {
           props.href = this.link + '?jwttoken=' + token
          }
      } else if (utils.isUrl(this.link)) {

        props.href = this.formatHref(this.link)
      } else {
        let route = null
        if (utils.isObject(this.link)) {
          route = utils.appendDefaultParamsToRoute(this.link)
        } else {
          route = utils.getRouteWithDefaultParams(this.link)
        }
        props.to = route
      }
      return props
    },
    boxClasses() {
      const classes = ['link-box']
      if (this.link) {
        classes.push('link-box--has-icon')
      }
      if (this.aspect) {
        if (this.aspect === '1/1') {
          classes.push('link-box--aspect-1-1')
        } else if (this.aspect === '16/9') {
          classes.push('link-box--aspect-16-9')
        } else if (this.aspect === '4/1') {
          classes.push('link-box--aspect-4-1')
        }
      }
      return classes
    },
    heroStyles() {
      const styles = {}
      if (this.variant.includes('hero')) {
        styles.minHeight = this.heroHeight
      }
      return styles
    },
    hoverStyles() {
      const styles = {}
      if (this.hover && this.hoverStyle) {
        styles.backgroundColor = this.hoverStyle.backgroundColor
        styles.color = this.hoverStyle.color
        styles.cursor = this.hoverStyle.cursor
        styles.transition = this.hoverStyle.transition
        styles.transform = this.hoverStyle.transform
      }
      return styles
    },
    boxStyles() {
      const cursorStyle = this.cursorCheck(this.tagProps.href)
      const cursor = cursorStyle?.split(':')[1]
      const styles = {
        color: this.replCssVar(this.textColor),
        background: this.backgroundColorGradient ? `linear-gradient(45deg, ${this.replCssVar(this.backgroundColor)} 0%, ${this.replCssVar(this.backgroundColorGradient)} 100%)` : this.replCssVar(this.backgroundColor),
        cursor,
      }
      if (this.backgroundImage) {
        styles.backgroundSize = 'cover'
        styles.backgroundRepeat = this.backgroundImageRepeat
          ? 'repeat'
          : 'no-repeat'
        styles.backgroundPosition = 'center'
        styles.backgroundImage = `url("${this.backgroundImage}")`
      }
      if (this.transition) {
        styles.transition = this.transition
      }
      return styles
    },
    cssProps() {
      const styles = {}
      if (this.titleSizeApp && this.isAppContainer) {
        styles.titleSize = this.titleSizeApp
      } else {
        styles.titleSize = this.titleSize
      }
      if (this.descSizeApp && this.isAppContainer) {
        styles.descSize = this.descSizeApp
      } else {
        styles.descSize = this.descSize
      }
      return styles
    },
    showTitle() {
      return (
        this.title || !!this.$slots.title || !!this.$scopedSlots.title
      )
    },
    showDescription() {
      return (
        this.description
        || !!this.$slots.description
        || !!this.$scopedSlots.description
      )
    },
    formatedDescription() {
      let text = this.description
      const token = this.token
      if (text.includes('{accessToken}') && token) {
        text = text.replace('{accessToken}', token)
      }
      if (text.includes('&lt;') || text.includes('&gt;') || text.includes('&quot')) {
        text = this.htmlDecode(text)
      }
      return text
    },
    inAppCheck() {
      if (this.isApp) {
        return this.inApp
      }
      return !this.onlyInApp
    }
  },
  methods: {
    htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html")
      return doc.documentElement.textContent
    },
    async receiveMessage(event) {
      if (event.detail.message === 'disableBanner') {
        this.showBanner = false
      }

      if (event.detail.message === 'activateBanner') {
        this.showBanner = true
      }

      if (event.detail.message === 'bannerControl') {
        if (this.displayOnPage.length > 0) {
          this.showBanner = !!this.displayOnPage.includes(event.detail.info)
        } else {
          this.showBanner = true
        }
      }

      if (event.detail.message === 'interceptUrl' ) {
        this.openLink(this.link)
      }
    },
    replCssVar(val) {
      return replaceCssVar(val)
    },
    showVideoProp() {
      this.videoPropModal.show = true
      // this.trackPlayVideo();
    },
    showIframe() {
      this.iframeClass = this.$el.className
      if (document.querySelector('.iframe-modal')) {
        this.$vnode.elm.className = 'link-box iframe-modal'
      }
      this.iframeModal = true
    },
    showModal() {
      this.liveDabClass = this.$el.className
      if (document.querySelector('.liveDab-modal')) {
        this.$vnode.elm.className = 'link-box liveDab-modal'
      }
      this.liveDabModal = true
    },
    goToArea(name, title, link, target) {
      this.trackingArea(name, title, link)
      window.open(link, target)
    },
    trackingArea(name, title, link) {
      if (utils.advancedTracking()) {
        const pageName = config.getPageName(this.$route.name)
        tracking.trackEvent(
          pageName,
          'Click',
          utils.advancedTrackingFormat(
            this.user.UserId,
            'Event',
            'LinkBox',
            name,
          ),
        )
      } else {
        tracking.trackEvent('LinkBox', 'Click', `${title} (${link})`)
      }
    },
    async tracking() {
      localStorage.removeItem('disableBack')
      if(this.componentName === 'ProgramDaysBox') localStorage.setItem('fromDaysBox', true)
      let { link } = this
      if (typeof this.link === 'object' && this.link !== null) {
        link = this.link.query?.filter ? `${this.link.name}:${this.link.query?.filter}` : this.link.name
      }

      if (typeof this.link === 'object' && this.defaultsConfig?.ticketSync) {
        link = this.tagProps.href
      }

      if (this.navigationHelper) localStorage.setItem('nav-header-name', this.navigationHelper)

      if (this.searchFilter?.preFilter) localStorage.setItem('filterActive', this.searchFilter.preFilter)
      if (this.searchFilter?.segment) localStorage.setItem('segmentActive', this.searchFilter.segment)
      if (this.searchFilter?.days) localStorage.setItem('dayFilter', JSON.stringify(this.searchFilter.days))
      if (this.searchFilter?.groups) localStorage.setItem('groupFilter', JSON.stringify(this.searchFilter.groups))
      if (this.searchFilter?.types) localStorage.setItem('typesFilter', JSON.stringify(this.searchFilter.types))
      if (this.searchFilter?.keywords) localStorage.setItem('keywordsFilter', JSON.stringify(this.searchFilter.keywords))
      if (this.searchFilter?.rooms) localStorage.setItem('roomsFilter', JSON.stringify(this.searchFilter.rooms))
      if (this.searchFilter?.pdays) localStorage.setItem('pdayFilter', JSON.stringify(this.searchFilter.pdays))
      if (this.searchFilter?.pgroups) localStorage.setItem('pgroupFilter', JSON.stringify(this.searchFilter.pgroups))
      if (this.searchFilter?.ptypes) localStorage.setItem('ptypesFilter', JSON.stringify(this.searchFilter.ptypes))
      if (this.searchFilter?.pkeywords) localStorage.setItem('pkeywordsFilter', JSON.stringify(this.searchFilter.pkeywords))
      if (this.searchFilter?.prooms) localStorage.setItem('proomsFilter', JSON.stringify(this.searchFilter.prooms))
      if (this.searchFilter?.text) localStorage.setItem('searchText', this.searchFilter.text)

      if (this.trackingContent) {
        // eslint-disable-next-line max-len
        trackingApi.trackCustomAction(this.trackingContent.Action, this.trackingContent.EntityId, this.trackingContent.ActionContext)
      } else if (this.trackingId) {
        trackingApi.trackCustomAction(this.image ? 'vmx-banner-adv' : 'vmx-linkbox-action', this.trackingId, this.$route.name)
      } else {
        trackingApi.trackCustomAction(this.image ? 'vmx-banner-adv' : 'vmx-linkbox-action', this.image ? this.link || 'No title set' : this.title || 'No title set', this.$route.name)
      }
      // else{
      //   await trackingApi.trackCustomAction('vmx-linkbox-action', null, 'default-linkbox')
      // }

      if (this.iframe) {
        this.showIframe()
      }
      if (this.video) {
        this.showVideoProp()
      }
      if (this.customModal) {
        this.showModal()
      }
      if (utils.advancedTracking()) {
        const pageName = config.getPageName(this.$route.name)
        let data = this.title
        if (!this.title && this.image) {
          data = link
        }
        tracking.trackEvent(
          pageName,
          'Click',
          utils.advancedTrackingFormat(
            this.user.UserId,
            'Event',
            'LinkBox',
            data,
          ),
        )
      } else {
        tracking.trackEvent(
          'LinkBox',
          'Click',
          `${this.$route.name} ${this.title} (${link})`,
        )
      }
    },
    action(url) {
      if(this.isAppContainer){
        if (url.href == 'https://www.marquette.edu/grad/nursing-educator-certificate.php?utm_source=Sigma+Conference&utm_medium=Mobile+banner+ad&utm_campaign=TCNE' || url.href == 'https://www.springerpub.com/nurses-making-policy-9780826166456.html?utm_source=Sigma&utm_medium=mobile-ad&utm_campaign=101023_Sigma_Patton_ad' || url.href == 'https://nursing.buffalo.edu/additional-info/employment-opportunities.html?utm_source=sigma&utm_medium=banner&utm_campaign=son-faculty&utm_content=2023' || url.href == 'https://hsc.unm.edu/nursing/' || url.href == 'https://nursing.georgetown.edu/degree-programs/doctoral/phd-nursing/' || url.href == 'https://www.commercebank.com/sigma') {
          const message = 'pdf-download'
              const messageObj = {
                message,
                content: url.href,
              }
              const stringifiedMessageObj = JSON.stringify(messageObj)
              if (window.webkit && window.webkit.messageHandlers) {
                window.webkit.messageHandlers.cordova_iab.postMessage(
                  stringifiedMessageObj,
                )
              }
              return;
        }
      }
      if (this.dataType === 'pdf' && this.isApp) {      
        if (window.location.href.indexOf('espghan') > -1 || window.location.href.indexOf('eha2022') > -1) {
          window.location.assign(`${this.appConfigV2.defaultV2.abstractS3Url}${encodeURIComponent(url?.href)}`)
        } else {
          this.openPdf(url)
        }
      } else if (this.dataType === 'qnalink' && this.isApp) {
          if(Vue.$cookies.get('access_token')) {
            window.open(`${url.href}?access_token=${Vue.$cookies.get('access_token')}&user_id=${Vue.$cookies.get('user_id')}&event_id=${Vue.$cookies.get('event_id')}&isApp=${this.isApp}&returnUrl=${window.location.href}`, '_self')
          } else {
            window.open(`${url.href}/${this.qnaInstance}?isApp=${this.isApp}&returnUrl=${window.location.href}`, '_self')
          }
          return
      } else if (this.dataType === 'qnalink') {
          if(Vue.$cookies.get('access_token')) {
            window.open(`${url.href}?access_token=${Vue.$cookies.get('access_token')}&user_id=${Vue.$cookies.get('user_id')}&event_id=${Vue.$cookies.get('event_id')}&isApp=${this.isApp}`, '_blank')
          } else {
            window.open(`${url.href}/${this.qnaInstance}?isApp=${this.isApp}`, '_blank')
          }
       
      } else if (this.dataType === 'tokenlink' && this.userState) {
        return
      } else if (this.dataType === 'link' && this.isApp) {
        this.openLink(url.href)
      } else if (this.checkHref(url?.href) === null) {
        this.$root.$emit('externalTrackingDataTransfer', url?.href)
        window.externalTrackingDataTransfer(url?.href)
      }
    },
  },
  watch: {
    iframeModal(val) {
      if (!val && document.querySelector('.iframe-modal')) {
        this.$vnode.elm.className = this.iframeClass
      }
    },
    liveDabModal(val) {
      if (!val && document.querySelector('.liveDab-modal')) {
        this.$vnode.elm.className = this.liveDabClass
      }
    },
  },
}
</script>

<style lang="scss">
.table-style {
  overflow-x: auto;

  table {
    width: 100%;
    table-layout : fixed;
  }
}
.link-box {
  height: 100%;
  display: block;
  text-decoration: none;
  /* Background image Justification */
  background-size: cover;
  background-position: center;

  &:hover {
    text-decoration: none;
  }

  area {
    outline: 0;
  }

  &.link-box--aspect-1-1 {
    position: relative;
    padding-top: 100%;

    .link-box-content {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.link-box--aspect-16-9 {
    position: relative;
    padding-top: 56.25%;

    .link-box-content {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &.link-box--aspect-4-1 {
    position: relative;
    padding-top: 25%;

    .link-box-content {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.link-box-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.link-box__text {
  flex: 1 1;
  font-size: 16px;
}

.link-box__title {
  div {
    // text-transform: uppercase;
    font-weight: bold;
    font-family: var(--link-box-font);
    mark {
      background-color: var(--link-box-mark);
      color: #fff;
      padding: 0 .5rem;
    }
  }

  font-size: 22px;
  margin: 20px;
}

.link-box__sectionTitle {
  div {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: var(--link-box-grid-gap);
  }
}

.link-box__description {
  margin: 20px;
}
.link-box__cta {
  margin: 20px;
}
.link-box__description div {
  font-family: var(--link-box-font);
}
.link-box__sectionDescription {
  margin: 20px 20px 20px 0;
}
.link-box__image {
  width: 100%;
  height: 100%;

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none; /* Standard syntax */

  object-fit: contain;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.link-box__map {
  width: 100%;
  height: 100%;
}

.link-box__icon {
  font-size: 30px;
  flex: 0 0 50px;
  margin: 0;

  .link-box__icon-image-path {
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }
}

area {
  cursor: pointer;
}

.linkbox-modal-container{
    width: 100%;
    height: auto;
    padding: 15px;
    border-radius: 10px;
    background-color: white;
  }
.in-app-linkbox-style {
    border-radius: .75rem;
    .link-box-content {
      flex-direction: column;
      align-items: center;
      gap: .5rem;
      padding: .75rem .5rem;
    }
    .link-box__icon {
      flex: 0 0 50px;
    }
    .link-box__icon > svg {
      font-size: 3rem;
    }
    .link-box__title {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 0;
      font-size: 1.25rem;
      line-height: 1.25rem;
    }
}
.link-box.icon-position-absolute {
  position: relative;
  .link-box__icon {
    position: absolute;
    bottom: 0;
    right: 10px;
    opacity: .15;
    font-size: 3rem;
  }
}
.link-box.hero {
  width: 100%;
  min-height: 50vh;
  display: flex;
  align-items: center;
  .link-box__cta {
    display: flex;
    justify-content: center;
    a {
      font-size: 1.75rem;
    }
  }
  .link-box-content {
    max-width: 1400px;
    width: 100%;
    height: unset;
    margin: auto;
    background-color: var(--link-box-frosted-background) ;
    backdrop-filter: blur(5px);
    border-radius: var(--linkbox-border-radius);
  }
  .link-box__title {
    font-size: 3rem;
    letter-spacing: -.025rem;
    font-weight: 800;
    line-height: 1.25;
    mark {
      background-color: var(--link-box-mark);
      color: #fff;
      padding: 0 .5rem;
    }
  }
  .link-box__description {
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 400;
  }
}
.link-box.hero-small {
    .link-box__title {
      font-size: 2.5rem;
    }
  }
  .link-box.hero-x-small {
    .link-box__title {
      font-size: 2rem;
    }
  }
@media (max-width: 768px){
    .link-box.hero {
    .link-box__title {
      font-size: 2rem;
    }
  }
  .link-box.hero-small {
    .link-box__title {
      font-size: 1.75rem;
    }
  }
  .link-box.hero-x-small {
    .link-box__title {
      font-size: 1.5rem;
    }
  }
  }
  .link-box.no-margin-description {
    .link-box__description {
      margin: 0;
    }
  }
  .link-box.no-margin-title {
    .link-box__title {
      margin: 0;
    }
  }
</style>
